
import TableCarp from './components/Carpeta/TableCarp';
import Modals from './components/Modals';


/**
 * @description This component handles the UI of the table of the carpetas. (see how to use the logic under this line)
 *
 * @tutorial in order to use this component you need to wrap it with the TablaCarpetaProvider
 * from that provider you can access the context and use the functions and states. 
    * the most important is the use of the filters.
 */
const TablaCarpetaV2 = () => {
    //? Remember to wrap all the component with the TablaCarpetaProvider

    return (
        <>
            <TableCarp />
            <Modals />
        </>
    );
}

export default TablaCarpetaV2;